<template>
  <div class="container">
    <div class="left-top">
      <div>
        <img src="../assets/images/logo.png" />
      </div>
      <div>
        <p>
          {{ title1 }}<br />
          {{ title2 }}
        </p>
      </div>
    </div>
    <div class="main-logo">
      <img :src="mainLogo" />
    </div>
    <ul>
      <li @click="goPath('https://law.cnki.net')">
        <h3>《中国法律智库平台》</h3>
      </li>
      <li @click="goPath('https://gw.cnki.net')">
        <h3>《公文大模型》</h3>
      </li>
      <li @click="goPath('https://thinker.cnki.net')">
        <h3>《两会书屋-心可书馆》</h3>
      </li>
      <li @click="goPath('https://aipat.cnki.net')">
        <h3>《知识产权检索分析系统》</h3>
      </li>
      <li @click="goPath('https://cp.cnki.net')">
        <h3>《CNKI公共文化知识资源总库》</h3>
      </li>
      <br />
      <li>
        <h3 @click="goPath1()">《产业大数据平台》</h3>
      </li>
    </ul>
    <!-- <p class="call">
      {{ call }}
    </p> -->
  </div>
</template>

<script>
import axios from 'axios'
import { pinyin } from 'pinyin-pro'
export default {
  data() {
    return {
      title1: '河北省第十四届人民代表大会第四次会议',
      title2: '政协河北省第十三届委员会第四次会议',
      call: '', //服务热线
      mainLogo: require('@/assets/images/main-logo.png')
    }
  },
  created() {},
  methods: {
    autosubmit(obj, path) {
      obj.action = this.myhost + '/loginid.aspx?p=' + encodeURI(path)
      obj.submit()
    },
    open(path) {
      window.open(path)
    },
    goPath(path) {
      axios
        .get('/api/center/auth')
        .then((res) => {
          console.log(res)
          const token = res.data
          const new_path = `https://my.cnki.net/IntegrateLogin/Redirect.ashx?token=${token}&ReturnUrl=${path}`
          window.open(new_path)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    goPath1() {
      axios
        .get('/api/center2/auth')
        .then((res) => {
          console.log(res)
          const token = res.data
          const new_path = `https://lianghui.chanyeos.com/smart-ke-b/#/freeLogin?token=${token}&redirect_to=home/homeSearch`
          window.open(new_path)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { city } = this.$route.query
      let cityName = pinyin(city, { toneType: 'none' })
      let resultCity = cityName.replace(/\s+/g, '')
      this.mainLogo = resultCity
        ? require(`@/assets/images/main-logo-${resultCity}.png`)
        : require('@/assets/images/main-logo.png')
      switch (city) {
        case '张家口':
          this.title1 = '张家口市第十五届人民代表大会第九次会议'
          this.title2 = '中国人民政治协商会议张家口市第十四届委员会第五次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'zhangjiakou':
          this.title1 = '张家口市第十五届人民代表大会第九次会议'
          this.title2 = '中国人民政治协商会议张家口市第十四届委员会第五次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '邯郸':
          this.title1 = '邯郸市第十六届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议邯郸市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'handan':
          this.title1 = '邯郸市第十六届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议邯郸市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break

        case '承德':
          this.title1 = '承德市第十五届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议承德市第十五届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break

        case 'chengde':
          this.title1 = '承德市第十五届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议承德市第十五届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break

        case '秦皇岛':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、13223439761'
          break
        case 'qinhuangdao':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、13223439761'
          break
        case '衡水':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'hengshui':
          this.title1 = ''
          this.title2 = ''
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '廊坊':
          this.title1 = '廊坊市第八届人民代表大会第八次会议'
          this.title2 = '中国人民政治协商会议廊坊市第八届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'langfang':
          this.title1 = '廊坊市第八届人民代表大会第八次会议'
          this.title2 = '政协廊坊市第八届委员会第四次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '沧州':
          this.title1 = '沧州市第十五届人民代表大会第七次会议'
          this.title2 = '政协沧州市第十二届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break
        case 'cangzhou':
          this.title1 = '沧州市第十五届人民代表大会第七次会议'
          this.title2 = '政协沧州市第十二届委员会第六次会议'
          this.call = '服务热线：400-810-9888、15230191819'
          break
        case '石家庄':
          this.title1 = '石家庄市第十五届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议石家庄市第十四届委员会第四次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case 'shijiazhuang':
          this.title1 = '石家庄市第十五届人民代表大会第七次会议‌'
          this.title2 = '中国人民政治协商会议石家庄市第十四届委员会第四次会议'
          this.call = '服务热线：400-810-9888、15732862138'
          break
        case '保定':
          this.title1 = '保定市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议保定市第十四届委员会第六次会议'
          this.call = '服务热线：400-810-9888、18515055920'
          break
        case 'baoding':
          this.title1 = '保定市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议保定市第十四届委员会第六次会议'
          this.call = '服务热线：400-810-9888、18515055920'
          break
        case '唐山':
          this.title1 = '唐山市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议唐山市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、13223439761'
          break
        case 'tangshan':
          this.title1 = '唐山市第十六届人民代表大会第七次会议'
          this.title2 = '中国人民政治协商会议唐山市第十三届委员会第六次会议'
          this.call = '服务热线：400-810-9888、13223439761'
          break

        default:
          this.title1 = '河北省第十四届人民代表大会第四次会议'
          this.title2 = '政协河北省第十三届委员会第四次会议'
          this.call = ''
          break
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: url('../assets/images/bg.png') no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
  .left-top {
    position: absolute;
    display: flex;
    align-items: center;
    left: 121px;
    top: 83px;
    img {
      width: 91px;
      margin-right: 15px;
    }
    p {
      padding-top: 5px;
      font-size: 14px;
      line-height: 20px;
      color: #d91a01;
      font-weight: bold;
    }
  }
  .main-logo {
    width: 579px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 126px;
    img {
      width: 579px;
    }
  }
  .left-bottom {
    position: absolute;
    left: 220px;
    bottom: 60px;
    font-size: 14px;
    color: #ffdd92;
  }
  ul {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 470px;
    width: 1040px;
    height: 240px;
    border-radius: 30px;
    background: linear-gradient(180deg, #e61a00 0%, rgba(232, 38, 13, 0) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px 30px;
    padding: 70px 100px;
    li {
      background: url(~@/assets/images/li.png) no-repeat;
      background-size: 100% 100%;
      width: 260px;
      height: 38px;
      line-height: 38px;
      border-radius: 30px;
      background: linear-gradient(270deg, #fef2dd 0%, #f9d9a6 100%);
      font-weight: bold;
      font-size: 14px;
      transition: all 0.3s;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #d91a01;
      // position: absolute;
      h3 {
        line-height: 38px;
        text-align: center;
      }
      // &:nth-of-type(1) {
      //   left: 0px;
      //   top: 0px;
      // }
      // &:nth-of-type(2) {
      //   left: 350px;
      //   top: 0;
      // }
      // &:nth-of-type(3) {
      //   left: 700px;
      //   top: 0;
      // }
      // &:nth-of-type(4) {
      //   left: 175px;
      //   bottom: 0;
      // }
      // &:nth-of-type(5) {
      //   left: 525px;
      //   bottom: 0;
      // }
    }
  }
  .call {
    position: absolute;
    top: 582px;
    left: 50%;
    transform: translateX(-50%);
    color: #fff1c1;
    padding-left: 40px;
    font-size: 16px;
  }
}
</style>
